import { createContext } from 'react'

export const AppNotificationsContext = createContext({
	notificationCount: 0,
	notifications: [],
});